import { Component, EventEmitter, inject, Input, input, Output } from '@angular/core';
import { Router } from '@angular/router';
import { Car } from '../../models/car-model';
import { Plans } from '../../shared/constants/plan.constants';
import { Statuses } from '../../shared/constants/status.constants';

@Component({
  selector: 'app-car-map-item',
  standalone: false,
  templateUrl: './car-map-item.component.html',
  styleUrl: './car-map-item.component.scss',
})
export class CarMapItemComponent {
  @Input() car!: Car;
  listId = input<string>('carItem');

  @Output() close = new EventEmitter<void>();

  private router = inject(Router);

  statuses = Statuses;
  plans = Plans;

  goToDetails(carId: number): void {
    this.router.navigate(['/cars', carId]);
  }

  onClose(event: MouseEvent): void {
    event.stopPropagation();
    this.close.emit();
  }

  isSponsered(): boolean {
    return this.car.isSponsered && new Date(this.car.sponseredExpireDate) > new Date();
  }
}
